<template>
    <div class="collect_wrap">
        <div class="collect">
            <!-- 顶部条状栏目 -->
            <div class="top flex-between">
                <div class="left_bar">
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                        <el-breadcrumb-item><i class="iconfont icon-shoucangjia" @click="toColloct">&nbsp;我的收藏夹</i></el-breadcrumb-item>
                        <el-breadcrumb-item v-if="subCollectName">{{subCollectName}}</el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
                <div>
                    <i v-show="subCollectName" class="iconfont icon-arrowLeft" @click="toColloct">&nbsp;返回</i>
                    <i v-show="!subCollectName" class="iconfont icon-xianxingwenjianjia" @click="favoritesVisible = true">&nbsp;新建收藏夹</i>
                </div>
            </div>
            <!-- 每项栏目内容 -->
            <div v-show="!subCollectName" class="tab_content">
                <div class="item flex-start" v-for="item in collectData" :key="item.id" @click="toSubCollect(item)">
                    <div class="img_wrap"><img src="../../assets/img/test.png" alt=""></div>
                    <div class="flex-column-between column_content">
                        <div class="file_name">{{item.favoritesName}}</div>
                        <div class="flex-between">
                            <div class="flex-between file_info">
                                <div>文件数：{{item.dataResourceNum}}</div>
                                <div>更新时间：{{item.updateTime}}</div>
                            </div>
                            <div class="flex-between file_edit">
                                <div class="edite_file"><i class="iconfont icon-bianji" @click.stop="editeFileVisible = true,fileId = item.id">&nbsp;编辑文件夹</i></div>
                                <div class="edite_file"><i class="iconfont icon-shanchu" @click.stop="deleteFileVisible = true,fileId = item.id">&nbsp;删除文件夹</i></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 收藏具体内容 -->
            <div v-show="subCollectName" class="tab_content">
                <div class="item flex-start" v-for="item in collectDataList" :key="item.id">
                    <div class="img_wrap"><img :src="item.imageUrl" alt=""></div>
                    <div class="flex-column-between column_content">
                        <div class="file_name">{{item.dataTitle}}</div>
                        <div class="flex-between">
                            <div class="file_info ellipsis">
                                <div>简介：{{item.summary}}</div>
                            </div>
                            <div class="flex-between file_edit">
                                <div class="edite_file"><i class="iconfont icon-jinru" @click="isStartVisible = true">&nbsp;进入环境</i></div>
                                <div class="edite_file" @click="cancelCollectVisible = true"><i class="iconfont icon-xingxing" @click="subCollectId = item.id,cancelCollectVisible = true">&nbsp;</i><span>取消收藏</span></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div  class="empty-wrap" v-if="collectDataList.length == 0">
                    <img src="../../assets/img/offshelf.png" alt="">
                </div>
            </div>
        </div>
        <div class="paging_wrap" v-if="pages.totals > 3">
            <el-pagination  background :page-size="3" layout="prev, pager, next"  @current-change="getCollectData" :current-page.sync="pages.currentPage" :total="pages.totals"></el-pagination>
        </div>
         <!-- 新建文件夹 -->
        <el-dialog title='新建文件夹' :visible.sync='favoritesVisible' width='30%' center>
            <el-input placeholder='输入文件夹名称' v-model='fileName'></el-input>
            <span slot='footer' class='dialog-footer'>
              <el-button type='primary' @click='createFile'>确 定</el-button>
              <el-button @click='favoritesVisible = false'>取 消</el-button>
            </span>
        </el-dialog>
        <!-- 编辑文件夹 -->
        <el-dialog title='编辑文件夹' :visible.sync='editeFileVisible' width='30%' center>
            <el-input v-model='fileName' placeholder='请输入文件夹名称'></el-input>
            <span slot='footer' class='dialog-footer'>
              <el-button type='primary' @click='updateFile'>确 定</el-button>
              <el-button @click='editeFileVisible = false'>取 消</el-button>
            </span>
        </el-dialog>
          <!-- 取消收藏 -->
        <el-dialog title='注意' :visible.sync='cancelCollectVisible' width='30%' center>
            <span class='notice_text_blue'>确认取消收藏？</span>
            <span slot='footer' class='dialog-footer'>
              <el-button type='primary' @click='cancelCollect'>是</el-button>
              <el-button @click='cancelCollectVisible = false'>否</el-button>
            </span>
        </el-dialog>
        <!-- 删除文件夹 -->
        <el-dialog title='删除文件夹' :visible.sync='deleteFileVisible' width='30%' center>
            <span>确认删除该收藏夹以及包含的{{ collectFileCount }}个文件？</span>
            <span slot='footer' class='dialog-footer'>
              <el-button type='primary' @click='deleteFile'>确 定</el-button>
              <el-button @click='deleteFileVisible = false'>取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {
    addFavorites,
    deleteFavorites,
    queryFavorites,
    queryResourceInFavorites,
    removeResource,
    updateFavorites
} from '../../utils/api';

let Base64 = require('js-base64').Base64;
export default {
    data() {
        return {
            fileId: '',//选择的收藏夹id
            fileName: '',
            subCollectId: '',//数据资源选中id
            pages: {
                currentPage: 1,
                    totals:1
                },
                collectData:[],
                collectDataList:[],//收藏夹详细列表
                favoritesVisible:false,
                editeFileVisible:false,
                deleteFileVisible:false,

                cancelCollectVisible:false,
                subCollectName:'',//选中文件夹名称
                collectFileCount:3,
            }
        },
        created(){
            // let url = document.location.href;
        },
        mounted(){

        },
        methods: {

            //取消收藏
            cancelCollect(){
                let params = {
                    favoritesIds:[this.fileId],
                    resourceId:this.subCollectId
                }
                removeResource(params).then(res => {
                    this.cancelCollectVisible = false;
                }).catch(err=>{})
            },

            //查询收藏夹列表
            getCollectData(){
                let params = {
                    keyWord:'',
                    page:this.pages.currentPage,
                    size:3
                }
                queryFavorites(params).then(res => {
                    this.collectData = res.data.list;
                    this.pages.totals = res.data.totalCount;
                }).catch(err=>{})
            },

            //新建收藏夹
            createFile(){
                addFavorites({ favoritesName: this.fileName }).then(res => {
                    this.fileName = '';
                    this.$message.success('创建成功');
                    this.favoritesVisible = false;
                    this.getCollectData();
                }).catch(err=>{})
            },

            //更改文件夹名称
            updateFile(){
                let params = {
                    favoritesId:this.fileId,
                    favoritesName:this.fileName
                }
                updateFavorites(params).then(res => {
                    this.fileName = '';
                    this.$message.success('修改成功');
                    this.editeFileVisible = false;
                    this.getCollectData();
                }).catch(err=>{})
            },

            //删除文件夹
            deleteFile(){
                deleteFavorites({ favoritesId: this.fileId }).then(res => {
                    this.$message.success('删除成功');
                    this.deleteFileVisible = false;
                    this.getCollectData();
                }).catch(err=>{})
            },

            //去收藏子页面
            toSubCollect(item){
                this.fileId = item.id
                this.subCollectName = item.favoritesName
                this.pages.currentPage = 1
                this.getFavoritesList()
            },

            //从子收藏返回上一级
            toColloct(){
                this.subCollectName = ''
                // this.modeId = 1
            },

            //获取收藏夹中的收藏列表
            getFavoritesList(){
                let params = {
                    keyword:'',
                    page:this.pages.currentPage,
                    size:3,
                    favoritesId:this.fileId
                }
                queryResourceInFavorites(params).then(res => {
                    this.collectDataList = res.data.list;
                    this.pages.totals = res.data.totalCount;
                }).catch(err=>{})
            },
        }
    }
</script>

<style lang="scss" scoped>
.collect_wrap{
    padding-bottom: 50px;

    .empty-wrap{
        background: white;
        margin-top: 10px;
    }
}
.paging_wrap{
    margin-top: 20px;
    height: 60px;
    text-align: center;
}
.collect{
    padding-bottom: 50px;
    min-height: 500px;
}
/deep/.el-tabs__nav-scroll{
    background: white;
    padding: 10px 0px 5px 10px;
    margin-top: 15px;
}
.top{
    height: 55px;
    box-sizing: border-box;
    background: white;
    box-sizing: border-box;
    margin-top: 15px;
    padding: 0px 50px 0px 0px;
    color: #848484;
    .icon-shoucangjia,.icon-xianxingwenjianjia{
        margin-right: 5px;
        // font-size: 18px;
    }
    .icon-arrowLeft:hover{
        color: #5277F7;
    }
    .icon-xianxingwenjianjia:hover{
        color: #FEA757;
    }
    .left_bar{
        min-width: 100px;
        // max-width: 250px;
        /deep/.el-breadcrumb__inner{
            line-height: 55px;
            font-size: 17px;
            color: white;
        }
        .icon-shoucangjia{
            color: white;
        }
        height: 55px;
        padding: 0px 50px;
        background: url(../../assets/img/collectBar.png) 0 0/100% 100% no-repeat;
    }
}
.tab_content{
    .item:hover{
        background: #FAFAFF;
        cursor: pointer;
    }
    .item{
        margin-top: 10px;
        box-sizing: border-box;
        background: white;
        padding: 20px 80px ;
        .img_wrap{
            width: 270px;
            height: 140px;
            img{
                height: 100%;
            }
        }
        .column_content{
            // background: red;
            padding: 30px 50px;
            box-sizing: border-box;
            width: 100%;
            height: 140px;
            color: #848484;
            .file_name{
                font-size: 26px;
                font-weight: bold;
                color: #3C3C3C;
            }
            .file_info{
                // width: 330px;
            }
            .file_edit{
                width: 250px;
                .icon-xingxing{
                    color: #FF9C00
                }

                .icon-jinru:hover{
                    // font-size: 22px;
                    color: #5279F6;
                }
                .icon-bianji:hover{
                    color: #FF9C3F;
                }
                .icon-shanchu:hover{
                    color: #F56C6C;
                }
            }
        }
    }
}

</style>

